import { render, staticRenderFns } from "./JitsiCalls.vue?vue&type=template&id=9d585936&"
import script from "./JitsiCalls.vue?vue&type=script&lang=js&"
export * from "./JitsiCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports